"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bancor = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const BANCOR_NETWORK_ABI = require("../../abi/bancor.network.json");
const transaction_builder_1 = require("../transaction-builder");
const BANCOR_NETWORK = {
    1: '0x2F9EC37d6CcFFf1caB21733BdaDEdE11c823cCB0',
};
class Bancor extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            minDestToken: '1',
            path: optimalRate.data.path,
        };
    }
    ;
    _swap(srcToken, destToken, data) {
        const bancorNetwork = data.bancorNetwork || BANCOR_NETWORK[this.network];
        const contract = new this.web3Provider.eth.Contract(BANCOR_NETWORK_ABI, bancorNetwork);
        const swapData = contract.methods.convert2(data.path, data.srcAmount, data.minDestToken, transaction_builder_1.NULL_ADDRESS, "0").encodeABI();
        return super.swap(srcToken, destToken, data, swapData, bancorNetwork);
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.Bancor = Bancor;
//# sourceMappingURL=bancor.js.map